// Delivery Countdown Custom Element
class DeliveryCountdown extends HTMLElement {
  constructor() {
    super();
    // Configurable variables
    this.LEAD_TIME_BEFORE_CUTOFF = 2; // days if before cutoff
    this.LEAD_TIME_AFTER_CUTOFF = 3; // days if after cutoff
    this.ORDER_DEADLINE_HOUR = 16; // 4pm
    this.COUNTDOWN_INTERVAL = null;
  }

  connectedCallback() {
    this.updateDeliveryCountdown();
    this.COUNTDOWN_INTERVAL = setInterval(
      () => this.updateDeliveryCountdown(),
      1000
    );
  }

  disconnectedCallback() {
    if (this.COUNTDOWN_INTERVAL) clearInterval(this.COUNTDOWN_INTERVAL);
  }

  getNextWeekday(date, weekday) {
    const result = new Date(date);
    result.setDate(date.getDate() + ((7 + weekday - date.getDay()) % 7));
    return result;
  }

  formatDay(date) {
    return date.toLocaleDateString(undefined, { weekday: "long" });
  }

  updateDeliveryCountdown() {
    const deliveryDayEl = this.querySelector("[data-delivery-day]");
    const countdownEl = this.querySelector("[data-countdown]");
    if (!deliveryDayEl || !countdownEl) return;

    const now = new Date();
    let deliveryDate = new Date(now);
    let cutoff = new Date(now);
    cutoff.setHours(this.ORDER_DEADLINE_HOUR, 0, 0, 0);

    // Weekend logic
    const isWeekend = now.getDay() === 6 || now.getDay() === 0; // Sat or Sun
    if (isWeekend) {
      // Next Monday 4pm
      const nextMonday = this.getNextWeekday(now, 1);
      cutoff = new Date(nextMonday);
      cutoff.setHours(this.ORDER_DEADLINE_HOUR, 0, 0, 0);
      // Delivery day is Wednesday
      deliveryDate = this.getNextWeekday(now, 3); // 3 = Wednesday
      deliveryDayEl.textContent = this.formatDay(deliveryDate);
    } else {
      // Weekday logic
      if (now < cutoff) {
        // Before cutoff: delivery in LEAD_TIME_BEFORE_CUTOFF days
        deliveryDate.setDate(now.getDate() + this.LEAD_TIME_BEFORE_CUTOFF);
      } else {
        // After cutoff: delivery in LEAD_TIME_AFTER_CUTOFF days
        deliveryDate.setDate(now.getDate() + this.LEAD_TIME_AFTER_CUTOFF);
        // Next cutoff is 4pm tomorrow
        cutoff = new Date(now);
        cutoff.setDate(now.getDate() + 1);
        cutoff.setHours(this.ORDER_DEADLINE_HOUR, 0, 0, 0);
      }
      // If delivery lands on weekend, push to Monday
      if (deliveryDate.getDay() === 6)
        deliveryDate.setDate(deliveryDate.getDate() + 2); // Sat->Mon
      if (deliveryDate.getDay() === 0)
        deliveryDate.setDate(deliveryDate.getDate() + 1); // Sun->Mon
      deliveryDayEl.textContent = this.formatDay(deliveryDate);
    }

    // Countdown logic
    let diff = cutoff - now;
    if (diff < 0) diff = 0;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    countdownEl.textContent = `${hours}h ${minutes}m ${seconds}s`;
  }
}

customElements.define("delivery-countdown", DeliveryCountdown);
